<template>
	<div class="study">
		<publicHeader @child-event="parentEvent"></publicHeader>
		<personalHeader :myInfo="myInfo"></personalHeader>
		
		<div class="personal bg_gray">
			<div class="w1200 flex">
				<personalNav :current="current"></personalNav>
				<div class="personal_r bg_white radius8">
					<div class="phone">
						<div class="phone_title mab30 flex">
							<span class="f20px">更换手机</span>
							<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
						</div>
						<div class="logon_item">
							<input type="text" v-model="mobile" placeholder="输入手机号" class="logon_item_input f16px" />
						</div>
						<div class="logon_item f16px">
							<div class="logon_item_hide">
								<input type="text" v-model="code" placeholder="输入验证码" class="logon_item_input f16px" />
								<button type="button" class="cl_violet logon_send" @click="send" :disabled="!sendTrue">{{sendText}}</button>
							</div>
						</div>
						<div class="phone_next cur tc f18px cl_white" @click="next">下一步</div>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	import personalHeader from '../../components/personal_header.vue'
	import personalNav from '../../components/personal_nav.vue'
	export default {
	  name: 'phone',
		components: {
			publicHeader,
			vfooter,
			personalHeader,
			personalNav,
		},
	  props: {
	    
	  },
		data () {
			return {
				myInfo: {},
				current: {
					navCur: 1,
					listCur: 0,
				},
				mobile: "", //手机号
				code: "",//验证码
				timer: 60,//倒计时
				sendText: "发送验证码",
				sendTrue: true,
			}
		},
		mounted() {
			
		},
		created() {
			
		},
		methods: {
			parentEvent (data) {
				this.myInfo = data;
			},
			//验证码倒计时
			send() {
				var that = this;
				that.$get("/api/login/send_sms_captcha",{
					phone: that.mobile,
					type: 4,
				})
				.then(res => {
					that.sendTrue = false;
					let auth_timer = setInterval(()=>{
						that.timer--;
						that.sendText = that.timer + "s后重试"
						if(that.timer<=0){
							that.sendTrue = true;
							that.sendText = "发送验证码";
							that.timer = 60;
							clearInterval(auth_timer);
						}
					},1000)
				});
			},
			//下一步
			next () {
				this.$get("/api/user/post_phone_edit",{
					phone: this.mobile,
					code: this.code,
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.$message({
						duration: 2000,
						message: res.msg,
						type: 'success'
					});
					setTimeout(() => {
						this.$router.push({path: '/personal'});
					}, 2000);
				});
			},
		},
	}
</script>

<style>
</style>
